<template>
    <div class="three-d-model" ref="ThreeDModel">
        <canvas id="c"></canvas>
        <button id="screenshot" type="button" v-if="screenshot"><v-icon>mdi-camera</v-icon></button>
    </div>
</template>

<script>
    //import * as THREE from "three";
    import {
        BoxGeometry,
        CylinderGeometry,
        DoubleSide,
        EdgesGeometry,
        HemisphereLight,
        LineBasicMaterial,
        LineSegments,
        Mesh,
        MeshBasicMaterial,
        MeshStandardMaterial,
        PerspectiveCamera,
        RingGeometry,
        Scene,
        WebGLRenderer,
    } from "three"; //"three/src/Three";
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import {Text}            from "troika-three-text";
//    import OrbitControls from "three-orbit-controls";

    export default {
        name: "ThreeDLogView",

        props: ["log", "cant", "cantType", "cutAlongLogAxis", "screenshot"],

        data() {
            return {
                scene:           null,
                renderer:        null,
                camera:          null,
                controls:        null,
                models:          [],
                enableDraw:      false,
                firstStart:      true,
                infoTable:       null
            }
        },

        watch: {
            enableDraw: function (val) {
                if (val) {
                    if (this.firstStart) {
                        this.initThree();
                        this.firstStart = false;
                    }

                    this.cleanup();
                    this.drawLog();
                    this.drawCant();
                    this.enableDraw = false;
                }
            },

            cantType: function () {
                this.cleanup();
                this.drawLog();
                this.drawCant();
            },
        },

        mounted () {
            //this.initThree();
            //this.cleanup();
            //this.drawLog();
            //this.drawCant();
        },

        methods: {
            /**
             * Добавление границ объекту
             *
             * @param {object} object Объект к которому добавляются границы
             */
            addEdges (object) {
                const edgeGeo = new EdgesGeometry (object.geometry);
                const edgeMat = new LineBasicMaterial({ color: 0x6e2c10, linewidth: 10 });
                const edges   = new LineSegments (edgeGeo, edgeMat);

                object.add(edges);
            },

            /**
            * Очистка объектов
            */
            cleanup () {
                while(this.models.length > 0) {
                    this.models[this.models.length - 1].geometry.dispose();
                    this.models[this.models.length - 1].material.dispose();
                    //this.models[this.models.length - 1].texture.dispose();
                    this.scene.remove(this.models[this.models.length - 1]);
                    this.models.pop();
                }

                this.models = undefined;
                this.models = [];
                //this.scene  = undefined;
                //this.renderer  = undefined;
                //this.camera  = undefined;
                //this.controls  = undefined;
            },

            /**
             * Расчёт шрифта для надписей с размерами сечений
             *
             * @param {number} t Высота доски
             * @param {number} w Ширина доски
             */
            calcFontSize (t, w) {
                let font = 0;

                if (t == w) {
                    if (t < 50) { font = t * w * 0.003 }
                    else if (t < 100) { font = t * w * 0.0015 }
                    else if (t < 150) { font = t * w * 0.0009 }
                    else if (t < 200) { font = t * w * 0.0006 }
                    else if (t < 250) { font = t * w * 0.0005 }
                    else if (t < 300) { font = t * w * 0.0004 }
                    else if (t < 400) { font = t * w * 0.0003 }
                    else { font = t * w * 0.0002 }
                } else {
                    if (t < 20) { font = t * w * 0.003 }
                    else if (t < 70) { font = t * w * 0.002 }
                    else if (t < 120) { font = t * w * 0.001 }
                    else { font = t * w * 0.0005 }
                }

                return font;
            },

            /**
         * Инициализация
         */
        initThree() {
            let width  = window.innerWidth;
            let height = window.innerHeight;
            const canvas = document.querySelector("#c");

            canvas.setAttribute("width", width);
            canvas.setAttribute("height", height);
            this.renderer = new WebGLRenderer({canvas});
            this.renderer.setClearColor(0xaaaaaa); //renderer.setClearColor(0xeae3e3);

            this.scene  = new Scene();
            this.camera = new PerspectiveCamera(45, width/height, 0.1, 10000);
            this.camera.position.set(this.log.dTop, this.log.dTop, (-this.log.len*1000/4 - this.log.dTop*3));

            this.controls = new OrbitControls(this.camera, canvas);
            this.controls.target.set(0, 0, 0);
            this.controls.update();

            const skyColor    = 0xffffff;
            const groundColor = 0x555555;
            const intensity   = 1;
            const light = new HemisphereLight(skyColor, groundColor, intensity);
            this.scene.add(light);

            requestAnimationFrame(this.render);
        },

        drawLog () {
            let k_len = 2;

            const geometryLog = new CylinderGeometry(this.log.dTop/2, this.log.dBottom/2, (this.log.len*1000)/k_len + 1, 64, 256, true, 0);
            const materialLog = new MeshStandardMaterial({
                color: 0x95651f,//0x7f3c3c,
                transparent: true,
                opacity: 0.75, //opacity: this.showLog ? 0.75 : 0,
            });
            materialLog.side = DoubleSide;

            let curvatureProgib = 0;
            if (this.log.curvature > 0) {
                curvatureProgib = ((this.log.len * this.log.curvature) / k_len) * 10;

                let curveStep1 = curvatureProgib / (256 * this.log.curvCenter);
                let curveStep2 = curvatureProgib / (256 * (1 - this.log.curvCenter));
                let curve = 0;
                let circleDots = 0;

                for (let dot = 0; dot < geometryLog.attributes.position.array.length; dot += 3) {
                    geometryLog.attributes.position.array[dot+2] += curve;
                    circleDots++;

                    if (circleDots == 64) {
                        if (dot < geometryLog.attributes.position.array.length * this.log.curvCenter) {
                            curve += curveStep1;
                        }
                        else {
                            curve -= curveStep2;
                        }
                        circleDots = 0;
                    }
                }
            }

            if (this.log.ellipseRatio > 0) {
                for (let dot = 0; dot < geometryLog.attributes.position.array.length; dot += 3) {
                    if (this.log.rotate == 0) {
                        geometryLog.attributes.position.array[dot] *= (1 - this.log.ellipseRatio/100);
                        geometryLog.attributes.position.array[dot+2] *= (1 + this.log.ellipseRatio/100);
                    }
                    else {
                        geometryLog.attributes.position.array[dot] *= (1 + this.log.ellipseRatio/100);
                        geometryLog.attributes.position.array[dot+2] *= (1 - this.log.ellipseRatio/100);
                    }
                }
            }

            this.models.push(new Mesh(geometryLog, materialLog));
            const log = this.models[this.models.length - 1];
            this.scene.add(log);

            log.rotation.x = Math.PI*2 * 3/4;

            this.models.push(new Text());
            let sizeLog = this.models[this.models.length - 1];
            sizeLog.text = "D = " + String(parseInt(this.log.dBottom));
            sizeLog.fontSize = this.log.dBottom > 100 ? 20 : 10;
            sizeLog.anchorX  = "50%";
            sizeLog.anchorY  = "50%";
            sizeLog.position.x = -this.log.dBottom/2;
            sizeLog.position.y = this.log.dBottom/2;
            sizeLog.position.z = this.log.len*1000/4 + 1;
            sizeLog.color = 0x000000;
            this.scene.add(sizeLog);

            this.models.push(new Text());
            sizeLog = this.models[this.models.length - 1];
            sizeLog.text = "D = " + String(this.log.dTop);
            sizeLog.fontSize = this.log.dTop > 100 ? 20 : 10;
            sizeLog.anchorX  = "50%";
            sizeLog.anchorY  = "50%";
            sizeLog.position.x = -this.log.dTop/2;
            sizeLog.position.y = this.log.dTop/2;
            sizeLog.position.z = -this.log.len*1000/4 + 1;
            sizeLog.rotation.y = Math.PI;
            sizeLog.color = 0x000000;
            this.scene.add(sizeLog);

            this.models.push(new Text());
            sizeLog = this.models[this.models.length - 1];
            sizeLog.text = "L = " + String(this.log.len);
            sizeLog.fontSize = this.log.dTop > 100 ? 24 : 12;
            sizeLog.anchorX  = "50%";
            sizeLog.anchorY  = "50%";
            sizeLog.position.y = this.log.dBottom/2 + curvatureProgib + 5;
            sizeLog.position.y += (this.log.dBottom/2 - this.log.dTop/2);
            sizeLog.rotation.y = Math.PI/2;
            sizeLog.color = 0x000000;
            this.scene.add(sizeLog);

            const materialRing = new MeshBasicMaterial( { color: 0x5f3f09, side: DoubleSide } ); //75531e
            const geometryTop  = new RingGeometry( this.log.dTop/2, this.log.dTop/2+1, 64 );
            if (this.log.ellipseRatio > 0) {
                for (let dot = 0; dot < geometryTop.attributes.position.array.length; dot += 3) {
                    if (this.log.rotate == 0) {
                        geometryTop.attributes.position.array[dot] *= (1 - this.log.ellipseRatio/100);
                        geometryTop.attributes.position.array[dot+1] *= (1 + this.log.ellipseRatio/100);
                    }
                    else {
                        geometryTop.attributes.position.array[dot] *= (1 + this.log.ellipseRatio/100);
                        geometryTop.attributes.position.array[dot+1] *= (1 - this.log.ellipseRatio/100);
                    }
                }
            }
            this.models.push(new Mesh(geometryTop, materialRing));
            const topRing = this.models[this.models.length - 1];
            this.scene.add(topRing);
            topRing.position.z = (-this.log.len*1000)/4 - 0.5;

            const geometryBot = new RingGeometry( this.log.dBottom/2, this.log.dBottom/2+1, 64 );
            if (this.log.ellipseRatio > 0) {
                for (let dot = 0; dot < geometryBot.attributes.position.array.length; dot += 3) {
                    if (this.log.rotate == 0) {
                        geometryBot.attributes.position.array[dot] *= (1 - this.log.ellipseRatio/100);
                        geometryBot.attributes.position.array[dot+1] *= (1 + this.log.ellipseRatio/100);
                    }
                    else {
                        geometryBot.attributes.position.array[dot] *= (1 + this.log.ellipseRatio/100);
                        geometryBot.attributes.position.array[dot+1] *= (1 - this.log.ellipseRatio/100);
                    }
                }
            }
            this.models.push(new Mesh(geometryBot, materialRing));
            const botRing = this.models[this.models.length - 1];
            this.scene.add(botRing);
            botRing.position.z = this.log.len*1000/4 + 0.5;
        },

        drawCant () {
            let k_len = 2;

            if (this.cantType == "cylinder") {
                const geometry = new CylinderGeometry( this.cant.optDiam/2, this.cant.optDiam/2, (this.log.len*1000)/k_len, 64, 128 );
                const material = new MeshBasicMaterial( {color: 0xebaf1a} );
                this.models.push(new Mesh( geometry, material ));
                const cylinder = this.models[this.models.length - 1];
                cylinder.rotation.x = Math.PI / 2;
                cylinder.position.y += this.cant.shift;
                this.scene.add( cylinder );

                this.addEdges(this.models[this.models.length - 1]);

                this.models.push(new Text());
                let size = this.models[this.models.length - 1];
                size.text = "\u00D8" + String(this.cant.optDiam);
                size.fontSize = this.calcFontSize(this.cant.optDiam, this.cant.optDiam)/2;
                size.anchorX  = "50%";
                size.anchorY  = "50%";
                size.position.x = -this.cant.optDiam/4;
                size.position.y = this.cant.optDiam/4;
                size.position.z = -this.log.len*1000/4 - 2;
                //size.rotation.y = Math.PI;
                size.rotation.x = Math.PI;
                size.rotation.z = Math.PI;
                size.color = 0x000000;
                this.scene.add(size);
            } else {
                const geometryBoard = new BoxGeometry (this.cant.optSide, this.cant.optSide, (this.log.len*1000)/k_len);
                const materialBoard = new MeshBasicMaterial( {color: 0xebaf1a});
                this.models.push(new Mesh (geometryBoard, materialBoard));
                const board = this.models[this.models.length - 1];
                board.rotation.z = Math.PI /2;
                board.position.y += this.cant.shift;
                this.scene.add (board);

                this.addEdges(this.models[this.models.length - 1]);

                this.models.push(new Text());
                let size = this.models[this.models.length - 1];
                size.text = String(this.cant.optSide) + "x" + String(this.cant.optSide);
                size.fontSize = this.calcFontSize(this.cant.optSide, this.cant.optSide)/2;
                size.anchorX  = "50%";
                size.anchorY  = "50%";
                size.position.x = -this.cant.optSide/4;
                size.position.y = this.cant.optSide/4;
                size.position.z = -this.log.len*1000/4 - 2;
                //size.rotation.y = Math.PI;
                size.rotation.x = Math.PI;
                size.rotation.z = Math.PI;
                size.color = 0x000000;
                this.scene.add(size);
            }

            let axisD = this.log.dTop > 300 ? 1 : 0.5;
            const geometryAxis = new CylinderGeometry( axisD, axisD, this.log.len*1000/k_len+10, 16, 64);
            let materialAxis = new MeshBasicMaterial( {color: 0x000000} );
            this.models.push(new Mesh (geometryAxis, materialAxis));
            const cantAxis = this.models[this.models.length - 1];
            cantAxis.rotation.x = Math.PI / 2;
            cantAxis.position.y += this.cant.shift;
            this.scene.add(cantAxis);

            if (this.cant.shift > 0) {
                materialAxis = new MeshBasicMaterial( {color: 0x95651f} );
                this.models.push(new Mesh (geometryAxis, materialAxis));
                const logAxis = this.models[this.models.length - 1];
                logAxis.rotation.x = Math.PI / 2;
                logAxis.position.y = 0;
                this.scene.add(logAxis);
            }
        },

        /**
         * Отрисовка
         */
        render () {
            if (this.resizeRendererToDisplaySize(this.renderer)) {
                const canvas = this.renderer.domElement;
                this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
                this.camera.updateProjectionMatrix();
            }

            if (this.scene !== undefined && this.camera !== undefined) {
                this.renderer.render(this.scene, this.camera);

                requestAnimationFrame(this.render);
            }

        },

        /**
         * Адаптация визуализатора под размер экрана
         *
         * @param {object} renderer Визуализатор
         *
         * @returns {bool} Флаг изменения размера
         */
        resizeRendererToDisplaySize (renderer) {
            const canvas = renderer.domElement;
            const width  = canvas.clientWidth;
            const height = canvas.clientHeight;
            const needResize = canvas.width !== width || canvas.height !== height;

            if (needResize) {
                renderer.setSize(width, height, false);
            }

            return needResize;
        },

        }
    }
</script>

<style lang="sass" scoped>
    #c
        height: 100%
        width: 100%
        background-color: #000

    button
        &#screenshot
            position: absolute
            padding: 10px
            margin: 2px
            border: none
            border-radius: 30px
            cursor: pointer
            >
                i
                    color: #000
            &:hover
                background: #fff

            &:focus
                outline: none

        &#screenshot
            left: 25px
            top: 25px

    #info
        background: none
        color: #000
        font-family: Arial, Helvetica, sans-serif
        font-size: 12px
        margin: 10px
        position: absolute
        bottom: 5px
</style>
